<template>
	<div class="main">
		<!--左上角斜线导航-->
		<nav class="nav_box nav_box_left">
			<div class="line">
				<div class="icon_dot_top"></div>
				<!--加盟信息-->
				<div class="icon icon_top icon_top_1" :class="[navid == 4? 'nav_active':'']"><i class="iconfont icon-7" @click.stop="onSelectNav($event)" data-navid="4"></i></div>
				<!--案例-->
				<div class="icon icon_top icon_top_2" :class="[navid == 3? 'nav_active':'']"><i class="iconfont icon-presentationbus" @click.stop="onSelectNav($event)" data-navid="3"></i></div>
				<!--公司产品介绍-->
				<div class="icon icon_top icon_top_3" :class="[navid == 2? 'nav_active':'']"><i class="iconfont icon-linggan" @click.stop="onSelectNav($event)" data-navid="2"></i></div>
				<!--公司简介-->
				<div class="icon icon_top icon_top_4" :class="[navid == 1? 'nav_active':'']"><i class="iconfont icon-shiyongwendang" @click.stop="onSelectNav($event)" data-navid="1"></i></div>
			</div>
			
			<div class="line_left_bottom"><div class="icon_dot"></div></div>
		</nav>
		<!--右下角斜线导航-->
		<div class="nav_box nav_box_right">
			<div class="line_right_top">
				<div class="icon_dot"></div>
				
			</div>
			
			<footer class="line_right_bottom">
				<div class="icon_dot"></div>
				<div class="icon icon_bottom icon_bottom_1" :class="[footerid == 1? 'nav_active':'']"><i class="iconfont icon-qrcode" @click.stop="onSelectFooter($event)" data-footerid="1"></i></div>
				<div class="icon icon_bottom icon_bottom_2" :class="[footerid == 2? 'nav_active':'']"><i class="iconfont icon-phone-fill" @click.stop="onSelectFooter($event)" data-footerid="2"></i></div>
				<div class="icon icon_bottom icon_bottom_3" :class="[footerid == 3? 'nav_active':'']"><i class="iconfont icon-location-fill" @click.stop="onSelectFooter($event)" data-footerid="3"></i></div>
				<div class="icon icon_bottom icon_bottom_4" :class="[footerid == 4? 'nav_active':'']"><i class="iconfont icon-IE" @click.stop="onSelectFooter($event)" data-footerid="4"></i></div>
				
				<div class="footer_box">
					<div class="footer_info_box footer_qrcode" v-show="footerid==1">
						<img src="../../assets/images/code.png"/>
					</div>
					<div class="footer_info_box footer_tel" v-show="footerid==2">
						<img src="../../assets/images/tel.png"/>
						<div>
							<p>加盟热线</p>
							<span>020-38105411</span>
						</div>
					</div>
					<div class="footer_info_box footer_addr" v-show="footerid==3">
						<img src="../../assets/images/addr.png"/>
						<div>
							<p>广州市天河区潭村路328号2楼</p>
							<p class="en">2F NO. 328 Tancun Road,Tianhe District Guangzhou</p>
						</div>
					</div>
					<div class="footer_info_box footer_web" v-show="footerid==4">
						<img src="../../assets/images/ie.png"/>
						<div>
							<p>广州裕凯酒业</p>
							<span>www.ykwine.com</span>
							<p>广州方帝斯</p>
							<span>www.ykfondis.com</span>
						</div>
					</div>
				</div>
			</footer>
		</div>
		<section class="main_box">
			<!--navid: 公司简介：1，公司产品介绍：2，案例：3，加盟信息：4，主页-home：0-->
			<home v-if="navid==0"></home>
			<company_profile v-else-if="navid==1"></company_profile>
			<company_product_introduction v-else-if="navid==2"></company_product_introduction>
			<product_case v-else-if="navid==3"></product_case>
			<joinus v-else-if="navid==4"></joinus>
		</section>
		
		<div class="footer_copyright">
			<p>◆一个未来百年品牌◆</p>
			<ul>
				<li><a href="javascript:void(0)" target="_blank"><img src="http://szcert.ebs.org.cn/Images/govIcon.gif" alt="工商网监"/></a></li>
				<li><a class="nolink" href="javascript:void(0)">&nbsp;&nbsp;© 裕凯酒业  版权所有 &nbsp;&nbsp;&nbsp;</a></li>
				<li><a href="http://www.miitbeian.gov.cn/" target="_blank">粤 &nbsp;&nbsp;ICP&nbsp;&nbsp;&nbsp;备16120694号-1</a></li>
			</ul>
		</div>
	</div>
	
	
	
</template>

<script>
	import NavFdsJs from './navfds.js';
    export default NavFdsJs;
	
	
</script>

<style>
	.main{
		height: 49vw;
		padding-top: 2%;
	}
	.nav_box{
		position: absolute;
		overflow: hidden;
	}
	.nav_box_left{
		top: 0;
		left: 0;
		width: 22.9%;
		height: 59.6%;
	}
	/*右上角斜线*/
	.line{
		width: 340px;
		height: 276px;
		position: relative;
		border-bottom: 1px solid #e7e7e7;
		transform:rotate(-45deg) translate(-120px, -90px);
	    -webkit-transform:rotate(-45deg) translate(-120px, -90px);
	    -moz-transform:rotate(-45deg) translate(-120px, -90px);
	    -ms-transform:rotate(-45deg) translate(-120px, -90px);
	    transform-origin: 0 0;
	    -webkit-transform-origin: 0 0;
	    -moz-transform-origin: 0 0;
	    -ms-transform-origin: 0 0;
	    z-index: 99;
	}
	.line>.icon{
		transform:rotate(45deg);
	    -webkit-transform:rotate(45deg);
	    -moz-transform:rotate(45deg);
	    -ms-transform:rotate(45deg);
	}
	.icon_dot_top{
		width: 6px;
		height: 6px;
		background: #E7E7E7;
		border-radius: 50%;
		position: absolute;
		top: 273px;
		left: -3px;
	}
	.icon_dot{
		width: 6px;
		height: 6px;
		background: #E7E7E7;
		border-radius: 50%;
		position: absolute;
		top: -3px;
		left: -3px;
	}
	.icon{
		text-align: center;
		line-height: 30px;
		width: 30px;
		height: 30px;
		border: 1px solid #e7e7e7;
		border-radius: 50%;
		background: #1c1c1c;
		position: absolute;
		color: #e7e7e7;
	}
	.icon>i{
		color: #e7e7e7;
		font-size: 20px;
	}
	.icon_top{
		top: 260px;
	}
	.icon_top_1{
		left: 30px;
	}
	.icon_top_2{
		left: 72px;
	}
	.icon_top_3{
		left: 114px;
	}
	.icon_top_4{
		left: 156px;
	}
	/*左下角斜角*/
	.line_left_bottom{
		width: 0;
		height: 130px;
		position: relative;
		border-right: 1px solid #e7e7e7;
		transform:rotate(45deg) translate(0, -90px);
	    -webkit-transform:rotate(45deg) translate(0, -90px);
	    -moz-transform:rotate(45deg) translate(0, -90px);
	    -ms-transform:rotate(45deg) translate(0, -90px);
	    transform-origin: 0 30%;
	    -webkit-transform-origin: 0 30%;
	    -moz-transform-origin: 0 30%;
	    -ms-transform-origin: 0 30%;
	}
	/*右下角斜线样式*/
	.nav_box_right{
		bottom: 0;
		right: 0;
		width: 300px;
		height: 350px;
	}
	.line_right_top{
		width: 180px;
		height: 150px;
		position: relative;
		border-top: 1px solid #e7e7e7;
		transform:rotate(-45deg) translate(70px, 125px);
	    -webkit-transform:rotate(-45deg) translate(70px, 125px);
	    -moz-transform:rotate(-45deg) translate(70px, 125px);
	    -ms-transform:rotate(-45deg) translate(70px, 125px);
	    transform-origin: 70% 0;
	    -webkit-transform-origin: 70% 0;
	    -moz-transform-origin: 70% 0;
	    -ms-transform-origin: 70% 0;
	    z-index: 99;
	}
	/*footer 样式*/
	/*左下角斜角*/
	.line_right_bottom{
		width: 0;
		height: 300px;
		position: relative;
		border-left: 1px solid #e7e7e7;
		transform:rotate(45deg) translate(35px, -90px);
	    -webkit-transform:rotate(45deg) translate(35px, -90px);
	    -moz-transform:rotate(45deg) translate(35px, -90px);
	    -ms-transform:rotate(45deg) translate(35px, -90px);
	    transform-origin: 0 50%;
	    -webkit-transform-origin: 0 50%;
	    -moz-transform-origin: 0 50%;
	    -ms-transform-origin: 0 50%;
	    z-index: 99;
	}
	.line_right_bottom>.icon,.footer_info_box{
		transform:rotate(-45deg);
	    -webkit-transform:rotate(-45deg);
	    -moz-transform:rotate(-45deg);
	    -ms-transform:rotate(-45deg);
	}
	.icon_bottom{
		left: -16px;
	}
	.icon_bottom_1{
		top: 30px;
	}
	.icon_bottom_2{
		top: 75px;
	}
	.icon_bottom_3{
		top: 120px;
	}
	.icon_bottom_4{
		top: 165px;
	}
	/*主体内容框架*/
	.main_box{
		width: 1200px;
		height: 90%;
		margin: 0 auto;
		box-sizing: border-box;
	}
	/*图标点击后的效果*/
	.nav_active{
		border-color: red;
	}
	.nav_active>i{
		color: red;
	}
	/*footer 提示样式*/
	.footer_box{
		width: 300px;
		height: 100%;
		position: absolute;
		z-index: -1;
	}
	.footer_info_box{
		-webkit-font-smoothing: antialiased;/*使低像素图标字体更清晰*/
	    -moz-osx-font-smoothing: grayscale;
		position: absolute;
	}
	.footer_info_box>div{
		position: absolute;
		color: #fff;
		top: 0;
		font-size: small;
		text-align: center;
	}
	.footer_qrcode{
		left: 20px;
		top: 10px;
	}
	.footer_qrcode>img{
		width: 100px;
		height: 138.5px;
	}
	.footer_tel{
		top: 19px;
		left: 20px;
	}
	.footer_tel>img{
		width: 130px;
		height: 130px;
	}
	.footer_tel>div{
		width: 100px;
		left: 20px;
		line-height: 3;
		padding-top: 30px;
	}
	.footer_addr{
		left: -10px;
		top: 26px;
	}
	.footer_addr>img{
		width: 190px;
		height: 130px;
	}
	.footer_addr>div{
		width: 110px;
		left: 65px;
		line-height: 1.5;
		padding: 16px 6px 0;
		word-break:break-all;
		box-sizing: border-box;
	}
	.footer_addr>div>.en{
		font-size: smaller;
	}
	.footer_web{
		left: -43px;
		top: 30px;
	}
	.footer_web>img{
		width: 220px;
		height: 125px;
	}
	.footer_web>div{
		left: 100px;
		width: 100px;
		height: 100px;
		padding: 30px 6px 0;
		box-sizing: border-box;
	}
	.footer_web>div>span{ font-size: smaller;}
	/* 备案样式*/
	.footer_copyright{
		color: #b1b1b1;
		font-size: smaller;
		text-align: center;
		margin-top: 30px;
	}
	.footer_copyright p{
		line-height: 30px;
	}
	.footer_copyright ul{
		display: inline-block;
		margin: 0 auto;
	}
	.footer_copyright ul li{
		float: left;
	}
	.footer_copyright ul li a{
		color: #b1b1b1;
		text-decoration: none;
	}
	.footer_copyright ul li img{
		max-height: 20px;
	}
	/*a标签无手指状态*/
	.nolink {
	    cursor: default;
	}
</style>


// WEBPACK FOOTER //
// src/components/navfds/navfds.vue